import React from "react";
import { Link } from "react-router-dom";
import { Popconfirm, Space } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { BreadcrumbsBar } from "../../../common/components/BreadcrumbsBar";
import { SvgIcon } from "../../../common/components/SvgIcon";

interface SupplierDetailTopPanelProps {
    supplierName: string;
    supplierId: number;
    showUpdate?: boolean;
    onUpdate?: () => void;
}

export const SupplierDetailTopPanel: React.FC<SupplierDetailTopPanelProps> = ({
    supplierName,
    supplierId,
    showUpdate,
    onUpdate,
}) => {
    const breadcrumbs = [
        {
            name: "Buyer briefs",
            path: "/supplier",
        },
        {
            name: `${supplierName}`,
            path: `/supplier/${supplierId}`,
        },
    ];

    return (
        <div>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <BreadcrumbsBar breadcrumbs={breadcrumbs} />
                {showUpdate ? (
                    <Popconfirm
                        title="New version is available. Update now?"
                        trigger="hover"
                        icon={null}
                        placement="right"
                        onConfirm={onUpdate}
                    >
                        <SvgIcon name="alert" size={12} color="#1890FF" />
                    </Popconfirm>
                ) : null}
            </div>
            <Link to="/supplier">
                <Space>
                    <ArrowLeftOutlined />
                    Back to Buyer briefs
                </Space>
            </Link>
        </div>
    );
};
